import React from 'react';
import '../../../components/base/Grid/GridStyles.scss';
import classNames from 'classnames';
import { useIntl } from 'react-intl';
import GridWrapper from '../../../components/base/Grid/GridWrapper';
import GridHeader from '../../../components/base/Grid/GridHeader';
import { statusClassName } from '../../../utils/formatters';
import { STATUS_ENUM } from '../../../configs';

export default function SessionGrid(props) {
  const {
    columns,
    data,
    loading = false,
    emptyText = '',
    onClickByRow = null,
    rowClassFormatter = () => {},
  } = props;
  const intl = useIntl();
  const { formatMessage } = intl;
  const isOnClick = onClickByRow && typeof onClickByRow === 'function';
  const empty = emptyText || formatMessage({ id: 'empty.data' });
  const onSelectRow = (item, index) => event => {
    if (!isOnClick) {
      return;
    }
    onClickByRow(item, event, index);
  };

  const renderCell = (row, item, key, rowKey) => {
    let content = row[item.dataField];
    const { bodyStyle = {}, dataClassName = '' } = item;
    if (item.formatter && typeof item.formatter === 'function') {
      content = item.formatter(content, row, rowKey);
    }
    return (
      <td
        key={key}
        style={bodyStyle}
        className={classNames('data-table-cell', dataClassName)}
      >
        {content}
      </td>
    );
  };

  const renderRow = (row, rowKey) => {
    if (row.status === STATUS_ENUM.ERROR) {
      return (
        <tr
          key={rowKey}
          className={classNames('data-table-row', { 'clickable-table-row': isOnClick }, rowClassFormatter(row))}
          onClick={onSelectRow(row, rowKey)}
        >
          {columns.map((item, key) => {
            if (!key) {
              return renderCell(row, item, key, rowKey);
            }
            return null;
          })}
          <td className={classNames('data-table-cell session-status-error', statusClassName(row.status))} colSpan={3}>
            {formatMessage({ id: 'complex.is.critical' })}
          </td>
        </tr>
      );
    }
    return (
      <tr
        key={rowKey}
        className={classNames('data-table-row', { 'clickable-table-row': isOnClick }, rowClassFormatter(row))}
        onClick={onSelectRow(row, rowKey)}
      >
        {columns.map((item, key) => (renderCell(row, item, key, rowKey)))}
      </tr>
    );
  };

  return (
    <GridWrapper {...props}>
      <GridHeader {...props} />
      <tbody className="data-table-content">
        {data && data.map(renderRow)}
        {(!data || data.length < 1) && empty && !loading ? (
          <tr>
            <td colSpan={columns.length || 0} className="text-center align-middle">{empty}</td>
          </tr>
        ) : null}
        {(!data || data.length < 1) && loading ? (
          <tr>
            <td colSpan={columns.length || 0} className="text-center align-middle">
              {formatMessage({ id: 'app.loading.process' })}
            </td>
          </tr>
        ) : null}
      </tbody>
    </GridWrapper>
  );
}
